import React, { useState } from "react";
import { showToast } from "../ShowToast/ToastNotification";
import { useTranslation } from "react-i18next";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { api_url } from "../../constant/constant";

const UploadCSV = ({ onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === "text/csv") {
            setFile(selectedFile);
        } else {
            showToast(t("pleaseSelectValidCSV"), "error");
            setFile(null);
        }
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!file) {
            showToast(t("pleaseSelectCSVToUpload"), "error");
            return;
        }

        setIsLoading(true);
        try {
            const token = localStorage.getItem("userToken");
            const formData = new FormData();
            formData.append("csv_file", file, file.name);

            const response = await fetch(api_url + "/users/upload-csv", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const result = await response.json();

            if (response.ok) {
                showToast(t("csvUploadedSuccessfully"), "success");
                showToast(t(result.message ), "success");
                setFile(null);
                if (onUploadSuccess) onUploadSuccess();
            } else {
                showToast(t(result.message || "Upload failed"), "error");
            }
        } catch (error) {
            showToast(t("errorOccurredRefresh"), "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            style={{
                border: "1px solid #EAEAEA",
                borderRadius: "10px",
                padding: "26px",
                margin: "20px",
                marginTop: "20px",
                backgroundColor: "#fff"
            }}
        >
            <div className="d-flex justify-content-between mb-3">
                <div className="pageTitle">{t('AddCSVFile')}</div>
                <Button variant="primary" onClick={() => navigate(-1)}>
                    {t('Back')}
                </Button>
            </div>

            <form onSubmit={handleUpload}>
                <div className="csv-upload-wrapper">
                    <label className="form-label">{t("SelectCSVFile")}</label>
                    <input
                        type="file"
                        className="form-control mb-2"
                        accept=".csv"
                        onChange={handleFileChange}
                    />
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <Spinner animation="border" size="sm" role="status" className="me-2" />
                                {t('Adding...')}
                            </>
                        ) : (
                            t('AddCSV')
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UploadCSV;
